(function () {
    'use strict';

    /* @ngdoc object
     * @name vcasset
     * @description
     *
     */
    angular
        .module('vcuser', [
            'vcuser.vcuser',
            'vcuser.vclogin'
        ]);
}());
